// Import the functions you need from the SDKs you need
import { initializeApp } from "https://www.gstatic.com/firebasejs/10.7.1/firebase-app.js";
import { getAnalytics } from "https://www.gstatic.com/firebasejs/10.7.1/firebase-analytics.js";
import { getAuth, GoogleAuthProvider, OAuthProvider, EmailAuthProvider, signInWithPopup, signInWithRedirect, getRedirectResult, signInWithEmailAndPassword, createUserWithEmailAndPassword, signInAnonymously, signInWithCredential, signOut, onAuthStateChanged, sendPasswordResetEmail, sendEmailVerification, fetchSignInMethodsForEmail, linkWithCredential, linkWithPopup, updateProfile, getAdditionalUserInfo } from "https://www.gstatic.com/firebasejs/10.7.1/firebase-auth.js";
import { getFirestore, collection, addDoc, getDocs, query, where, orderBy, limit, Timestamp, deleteDoc, doc, getDoc, setDoc } from "https://www.gstatic.com/firebasejs/10.7.1/firebase-firestore.js";

// Check if Firebase configuration is available
const isFirebaseConfigured = () => {
    return window.firebaseConfigReady === true && 
           window.FIREBASE_API_KEY && 
           window.FIREBASE_PROJECT_ID && 
           window.FIREBASE_APP_ID;
};

// Initialize placeholder values for when Firebase is not configured
let app = null;
let analytics = null;
let db = null;
let auth = null;
let googleProvider = null;
let appleProvider = null;

// Check configuration status once without polling
if (!isFirebaseConfigured()) {
    // Log a single warning message instead of flooding the console
    if (window.firebaseConfigReady === false) {
        console.info('Firebase: Configuration disabled - authentication features unavailable');
    } else {
        console.info('Firebase: Configuration not available - authentication features disabled');
    }
    
    // Set global flags to indicate Firebase is not available
    window.firebaseAuth = null;
    window.firebaseDB = null;
    window.firebaseModules = null;
    window.firebaseInitialized = false;
} else {
    // Firebase is configured, proceed with initialization
    console.log('Firebase: Configuration verified, initializing...');

    // Your web app's Firebase configuration
    // For Firebase JS SDK v7.20.0 and later, measurementId is optional
    const firebaseConfig = {
        apiKey: window.FIREBASE_API_KEY,
        authDomain: `${window.FIREBASE_PROJECT_ID}.firebaseapp.com`,
        databaseURL: `https://${window.FIREBASE_PROJECT_ID}-default-rtdb.firebaseio.com`,
        projectId: window.FIREBASE_PROJECT_ID,
        storageBucket: `${window.FIREBASE_PROJECT_ID}.firebasestorage.app`,
        messagingSenderId: "119772776012",
        appId: window.FIREBASE_APP_ID,
        measurementId: "G-XWY8B7TQTZ"
    };

    // Initialize Firebase
    app = initializeApp(firebaseConfig);
    analytics = getAnalytics(app);
    console.log('Firebase: ✓ App initialized with Analytics');

    // Initialize Cloud Firestore and get a reference to the service
    db = getFirestore(app);
    console.log('Firebase: ✓ Firestore initialized');

    // Initialize Firebase Authentication and get a reference to the service
    auth = getAuth(app);
    console.log('Firebase: ✓ Auth initialized');

    googleProvider = new GoogleAuthProvider();

    // Initialize Apple provider
    appleProvider = new OAuthProvider('apple.com');

    // Configure Apple provider
    appleProvider.setCustomParameters({
        // Localize the Apple authentication screen in a specific language.
        // locale: 'en_US'
    });

    // Request full name and email from Apple
    appleProvider.addScope('email');
    appleProvider.addScope('name');

    // Make Firebase available globally and notify other modules
    window.firebaseAuth = auth;
    window.firebaseDB = db;
    window.firebaseModules = {
        onAuthStateChanged,
        signInWithEmailAndPassword,
        createUserWithEmailAndPassword,
        signInAnonymously,
        signInWithCredential,
        signOut,
        GoogleAuthProvider,
        OAuthProvider,
        EmailAuthProvider,
        signInWithPopup,
        signInWithRedirect,
        getRedirectResult,
        fetchSignInMethodsForEmail,
        linkWithCredential,
        linkWithPopup,
        updateProfile,
        sendPasswordResetEmail,
        sendEmailVerification,
        collection,
        addDoc,
        getDocs,
        query,
        where,
        orderBy,
        limit,
        Timestamp,
        deleteDoc,
        doc,
        getDoc,
        setDoc,
        googleProvider,
        appleProvider
    };
    window.firebaseInitialized = true;

    console.log('Firebase: ✓ Global objects set, dispatching ready event');

    // Dispatch event to notify other modules Firebase is ready
    window.dispatchEvent(new CustomEvent('firebaseReady', { 
        detail: { auth, db, modules: window.firebaseModules } 
    }));
}

export { 
    auth, 
    db, 
    googleProvider,
    appleProvider,
    GoogleAuthProvider,
    OAuthProvider,
    EmailAuthProvider,
    signInWithPopup,
    signInWithRedirect,
    getRedirectResult,
    fetchSignInMethodsForEmail,
    linkWithCredential,
    linkWithPopup,
    getAdditionalUserInfo,
    updateProfile, 
    signInWithEmailAndPassword, 
    createUserWithEmailAndPassword, 
    signInAnonymously,
    signInWithCredential,
    signOut, 
    onAuthStateChanged,
    sendPasswordResetEmail,
    sendEmailVerification,
    collection,
    addDoc,
    getDocs,
    query,
    where,
    orderBy,
    limit,
    Timestamp,
    deleteDoc,
    doc,
    getDoc,
    setDoc
};